import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import domConstructTyped from 'dojo/dom-construct';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
// template-instantiated child widgets (data-dojo-type) — bare side-effect imports.
import "../../../more/HintBox";
import "../../../more/SelectBox";
import "../../../moreCore/UI/Multiselect/Multiselect";
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import template from './VehicleManageForm.html?raw';

// create() calls pass numeric innerHTML/value — alias dom-construct to any. Behaviour unchanged.
const domConstruct: any = domConstructTyped;

class VehicleManageForm extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    entity: any = null;
    formData: any = {
        ID: null,
        tuev: null,
        asu: null
    };
    currentData: any = null;
    isDirty = false;
    isValid = true;

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.RequestManager.silentExceptions = true;

        this.populateSelectControls();
    }

    startup(bReload?: any): void {
        super.startup.apply(this, arguments as any);
    }

    populateSelectControls(): void {

        domConstruct.create("option", {
            innerHTML: "",
            value: ""
        }, this.vehicleTuevDateMonth);
        domConstruct.create("option", {
            innerHTML: "",
            value: ""
        }, this.vehicleAsuDateMonth);

        for (var i = 0; i < 12; i++) {
            let d = new Date();
            d.setMonth(i);

            let monthName = d.toLocaleString("default", { month: "long" });

            let optionTuev = domConstruct.create("option", {
                innerHTML: monthName,
                value: (i + 1).toLocaleString("de-AT", { minimumIntegerDigits: 2 })
            });
            domConstruct.place(optionTuev, this.vehicleTuevDateMonth);

            let optionAsu = domConstruct.create("option", {
                innerHTML: monthName,
                value: (i + 1).toLocaleString("de-AT", { minimumIntegerDigits: 2 })
            });
            domConstruct.place(optionAsu, this.vehicleAsuDateMonth);
        }


        domConstruct.create("option", {
            innerHTML: "",
            value: ""
        }, this.vehicleTuevDateYear);
        domConstruct.create("option", {
            innerHTML: "",
            value: ""
        }, this.vehicleAsuDateYear);

        for (var i = -5; i <= 10; i++) {
            let d = new Date();
            let year = d.getFullYear() + i;

            let optionTuev = domConstruct.create("option", {
                innerHTML: year,
                value: year
            });
            domConstruct.place(optionTuev, this.vehicleTuevDateYear);

            let optionAsu = domConstruct.create("option", {
                innerHTML: year,
                value: year
            });
            domConstruct.place(optionAsu, this.vehicleAsuDateYear);
        }
    }

    _setValues(entity: any): void {

        this.entity = entity;
        this.vehicleInfo.innerHTML = entity.tmp_vehicle_info;

        let tuevMonth = entity.tuev.split(".")[0];
        let tuevYear = entity.tuev.split(".")[1];

        let asuMonth = entity.asu.split(".")[0];
        let asuYear = entity.asu.split(".")[1];

        this.vehicleTuevDateMonth.value = tuevMonth;
        this.vehicleTuevDateYear.value = tuevYear;

        this.vehicleAsuDateMonth.value = asuMonth;
        this.vehicleAsuDateYear.value = asuYear;

        this.formData.ID = entity.ID;

        this.serializeData();

        this.currentData = JSON.stringify(this.formData);
        this.checkDirty();
    }

    serializeData(): void {

        this.showErrorMessage(false);

        if (this.vehicleTuevDateMonth.value && this.vehicleTuevDateYear.value) {

            this.formData.tuev = `${this.vehicleTuevDateMonth.value}.${this.vehicleTuevDateYear.value}`;
        } else {

            this.formData.tuev = "";
        }

        if (this.vehicleAsuDateMonth.value && this.vehicleAsuDateYear.value) {

            this.formData.asu = `${this.vehicleAsuDateMonth.value}.${this.vehicleAsuDateYear.value}`;
        } else {

            this.formData.asu = "";
        }


        this.checkDirty();
        this.checkValid();
        console.debug(this.formData, this.vehicleAsuDateMonth);
    }

    checkValid(): void {

        //if (this.formData.tuev && this.formData.asu) {
        //    this.isValid = true;
        //} else {
        //    this.isValid = false;
        //}

        if ((this.vehicleTuevDateMonth.value && !this.vehicleTuevDateYear.value)
            || (!this.vehicleTuevDateMonth.value && this.vehicleTuevDateYear.value)) {

            this.isValid = false;
            return;
        }



        if ((this.vehicleAsuDateMonth.value && !this.vehicleAsuDateYear.value)
            || (!this.vehicleAsuDateMonth.value && this.vehicleAsuDateYear.value)) {

            this.isValid = false;
            return;
        }

        this.isValid = true;
    }

    checkDirty(): void {

        this.isDirty = this.currentData !== JSON.stringify(this.formData);

        this.emit("VM_Form_Changed");
    }

    _onClick_Button_Save(): void {

        if (!this.isValid) {

            this.showErrorMessage(true, "Daten nicht gültig!");
            return;
        }

        this.showErrorMessage(false);

        this.StandbyStart();

        var url = window.appRoot + "JDM/SaveVehicleChanges";

        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(this.formData)
            },
            lang.hitch(this, this._onSaveVehicleChangesResponse),
            lang.hitch(this, this._onSaveVehicleChangesError),
            false // sync
        );
    }

    _onSaveVehicleChangesResponse(response: any): void {

        this.StandbyStop();

        let saveDlg = new GenericDialog();
        saveDlg._setTopCloseBtnAttr(true);
        saveDlg._setHeaderAttr(this.translations["VehicleManage_Form_SaveVehicleInfoPopup_Header"]);
        saveDlg.hideSubtitleNode(true);
        saveDlg.set("ok", true);
        saveDlg._setContentAttr(this.translations["VehicleManage_Form_SaveVehicleInfoPopup_Message"]);

        domStyle.set(saveDlg.textNode, "height", "unset");
        domStyle.set(saveDlg.textNode.parentNode as any, "width", "600px");
        domStyle.set(saveDlg.textNode.parentNode as any, "margin-top", "150px");

        saveDlg.show();

        this.emit("CloseVehicleManageForm");
        this.destroy();
    }

    _onSaveVehicleChangesError(error: any): void {

        this.showErrorMessage(true, error.Message);
    }

    _onSelectDates(): void {

        this.serializeData();
    }

    showErrorMessage(showError: any, message?: any): void {

        if (showError === false) {

            domClass.add(this.errorMessageContainer, "w3-hide");
            this.errorMessageText.innerHTML = "";
            return;
        }

        domClass.remove(this.errorMessageContainer, "w3-hide");
        this.errorMessageText.innerHTML = message;
    }
}
VehicleManageForm.prototype.declaredClass = 'WidgetCollection.JDM.VehicleManage.VehicleManageForm';

export default mdsWidget(VehicleManageForm);
